'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('tvs_motors_ld_reportspec', {
      url: '/tvs_motors_ld_reportspec',
      template: '<tvsmotorsldreportspectab></tvsmotorsldreportspectab>'
    });
}
